var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.convenio.idSituacaoConvenio != 9)?_c('span',{staticClass:"text-succesx float-left mr-1"},[_c('i',{staticClass:"fa fa-check fa-lg icon-button",attrs:{"title":"Conferir Prestação"},on:{"click":function($event){$event.stopPropagation();return _vm.confirmarConferir(_vm.prestacaoContasFinalLancamento.idPrestacaoContasFinal)}}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }